import { render, staticRenderFns } from "./Browse.vue?vue&type=template&id=23d3aa6d&scoped=true&"
import script from "./Browse.vue?vue&type=script&lang=js&"
export * from "./Browse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3aa6d",
  null
  
)

export default component.exports